<template>
<el-col :span="8">
    <el-card class="box-card" style="height:440px;">
        <div slot="header" class="clearfix">
            <span>数据中心综合能力</span>
            <el-popover
                    placement="top"
                    title=""
                    width="200"
                    trigger="hover"
                    content="PUE是汇总统计所有数据中心的季度抄表数据，监察和安全指数是汇总统计所有部门的季度数据">
                <el-button slot="reference" type="text" style="float:right;padding: 3px 0;color:#666;"><i class='el-icon-question'></i></el-button>
            </el-popover>
            <div class="float-r" v-if="false">
            <el-date-picker
                    size="small"
                    v-model="searchMouth"
                    type="month"
                    @change="nouthChange"
                    value-format="yyyy-MM"
                    :editable="false"
                    :clearable="false"
                    placeholder="选择季度" style="float:right;margin-top:-6px;">
            </el-date-picker>
            </div>
        </div>
        <div class="blocktab">
            <i class="el-icon-info" style="font-size: 10px;">季度评定综合能力,即三、六、九和十二月才能查询到排名情况</i>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="综合" name="first" v-if="false">
                    <div class="bg-orange rank" v-if="finalDeptInfos.length>0">
                        <el-row :gutter="20">
                            <el-col :span="4" :offset="1"><img  style="width: 40px; height: 40px;margin-top:30px;"  src="@/views/board/boss/pueAndAllRound/img/rank.png" /><p class="bold text-center" style="font-size: 12px;">排名榜</p></el-col>
                            <el-col :span="19">
                                <div class="rankscroll">
                                    <el-row>
                                      <span v-for="(item, index) in finalDeptInfos" >
                                            <el-col :span="6" style="margin-top:10px;"><span class="red-font bold">{{'第'+(item.ranking)+'名'}}</span></el-col>
                                            <el-col :span="18" style="margin-top:10px;"><span class="red-font">{{item.name}}</span></el-col>
                                        </span>
                                    </el-row>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="finalDeptInfos.length<=0"><img style="margin-top:30px;width: 60%;margin:auto 20%;"  src="@/views/board/boss/pueAndAllRound/img/none.png" /></div>
                </el-tab-pane>
                <el-tab-pane label="PUE" name="second">
                    <div class="bg-orange rank" v-if="pueInfos.length>0">
                        <el-row :gutter="20">
                            <el-col :span="4" :offset="1"><img  style="width: 40px; height: 40px;margin-top:30px;"  src="@/views/board/boss/pueAndAllRound/img/rank.png" /><p class="bold text-center" style="font-size: 12px;">排名榜</p></el-col>
                            <el-col :span="19">
                                <div class="rankscroll">
                                    <el-row>
                                       <span v-for="(item, index) in pueInfos" >
                                            <el-col :span="6" style="margin-top:10px;"><span class="red-font bold">{{'第'+(item.ranking)+'名'}}</span></el-col>
                                            <el-col :span="18" style="margin-top:10px;"><span class="red-font">{{item.sysRoomName}}</span></el-col>
                                        </span>
                                    </el-row>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="pueInfos.length<=0"><img style="margin-top:30px;width: 60%;margin:auto 20%;"  src="@/views/board/boss/pueAndAllRound/img/none.png" /></el-image></div>
                </el-tab-pane>
                <el-tab-pane label="监察" name="third">
                    <div class="bg-orange rank" v-if="looks.length>0">
                        <el-row :gutter="20">
                            <el-col :span="4" :offset="1"><img  style="width: 40px; height: 40px;margin-top:30px;"  src="@/views/board/boss/pueAndAllRound/img/rank.png" /><p class="bold text-center" style="font-size: 12px;">排名榜</p></el-col>
                            <el-col :span="19">
                                <div class="rankscroll">
                                    <el-row>
                                        <span v-for="(item, index) in looks" >
                                            <el-col :span="6" style="margin-top:10px;"><span class="red-font bold">{{'第'+(item.ranking)+'名'}}  </span></el-col>
                                            <el-col :span="18" style="margin-top:10px;"><span class="red-font">{{item.assessmentobjname}}</span></el-col>
                                        </span>

                                    </el-row>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="looks.length<=0"><img style="margin-top:30px;width: 60%;margin:auto 20%;"  src="@/views/board/boss/pueAndAllRound/img/none.png" /></div>
                </el-tab-pane>
                <el-tab-pane label="安全指数" name="fourth">
                    <div class="bg-orange rank" v-if="finalDeptInfos.length>0">
                        <el-row :gutter="20">
                            <el-col :span="4" :offset="1"><img  style="width: 40px; height: 40px;margin-top:30px;"  src="@/views/board/boss/pueAndAllRound/img/rank.png" /><p class="bold text-center" style="font-size: 12px;">排名榜</p></el-col>
                            <el-col :span="19">
                                <div class="rankscroll">
                                    <el-row>
                                       <span v-for="(item, index) in finalDeptInfos" >
                                            <el-col :span="6" style="margin-top:10px;"><span class="red-font bold">{{'第'+(item.ranking)+'名'}}</span></el-col>
                                            <el-col :span="18" style="margin-top:10px;"><span class="red-font">{{item.name}}</span></el-col>
                                        </span>
                                    </el-row>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="finalDeptInfos.length<=0"><img style="margin-top:30px;width: 60%;margin:auto 20%;"  src="@/views/board/boss/pueAndAllRound/img/none.png" /></div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </el-card>
</el-col>
</template>

<script>
    import {athubAxios} from '../../../../util'
    import CommonApi from "@/api/common"
    import {COMMON_SERVER} from '@/api/server'
   // import { createNamespacedHelpers } from 'vuex';
    //const deptNSHelper = createNamespacedHelpers( "dept" );
    import {queryLooksInfo,queryPrimissionDepts,queryFsi,queryDcnumByDepts,queryPueBySysRooms
    } from '@/api/bossBoard/pueAndAllRound/allRound.js'

    let that;
    export default {
        name: 'allRound',
        components: {},

        data() {
            return {
                aa:[1,2,3,4],
                //图片
                rank:require("@/views/board/boss/pueAndAllRound/img/rank.png"),
                none:require("@/views/board/boss/pueAndAllRound/img/none.png"),
                //默认当前月份
                searchMouth:new Date().getFullYear() + '-' + this.addZero(new Date().getMonth() + 1),
                //默认显示综合tab
                activeName:'second',

                //监察页面最终排名信息数据
                looks:[],
                //监察页面获取的园区（部门）集合数据
                deptList: [],

                //安全指数页面/综合页面根据权限获取园区（部门）集合数据
                permissionDeptList:[],
                //安全指数页面/综合页面根据权限获取园区（部门）集合数据只有ID
                deptIds:[],
                //安全指数页面/综合页面最终页面显示的数据集合
                finalDeptInfos:[],

                //PUE有权限的数据中心
                SysRooms:[],
                //PUE有权限数据中心ID集合
                sysRoomIdsArr:[],
                //PUE 数据MAP 供根据sysRoomId获取对应的数据中心名称
                sysRoomMap:null,
                //PUE页面最终显示数据集合
                pueInfos:[],
            }
        },
        methods: {
            async nouthChange(){

                //监察查询
                var infos=await queryLooksInfo(this.searchMouth);
                this.looks=this.sortFractionLook(infos);
                this.looks.forEach(e =>{
                    this.deptList.forEach(h => {
                        if (e.assessmentobj == h.id) {
                            e.assessmentobjname = h.name;
                        }
                    })
                })

                //安全指数页面和综合页面查询
                if(this.searchMouth.match('-03')||this.searchMouth.match('-06')||this.searchMouth.match('-09')||this.searchMouth.match('-12')){
                    if(this.searchMouth.match('-03')){
                        var startTime=this.searchMouth.split('-')[0]+'-01-01';
                        var endTime = this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                'yyyy-MM-dd'))[1];

                        //查询 PUE
                        var pues=await queryPueBySysRooms(this.sysRoomIdsArr,startTime,endTime);
                        this.pueInfos=this.sumByRoomIdCompute(pues);

                        var infoArr=await queryFsi(this.deptIds,startTime,endTime);
                        this.finalDeptInfos=this.forEachEqualsInfo(infoArr,this.permissionDeptList);


                    }else if(this.searchMouth.match('-06')){
                        var startTime=this.searchMouth.split('-')[0]+'-04-01';
                        var endTime = this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                'yyyy-MM-dd'))[1];

                        //查询 PUE
                        var pues=await queryPueBySysRooms(this.sysRoomIdsArr,startTime,endTime);
                        this.pueInfos=this.sumByRoomIdCompute(pues);

                        var infoArr=await queryFsi(this.deptIds,startTime,endTime);
                        this.finalDeptInfos=this.forEachEqualsInfo(infoArr,this.permissionDeptList);


                    }else if(this.searchMouth.match('-09')){
                        var startTime=this.searchMouth.split('-')[0]+'-07-01';
                        var endTime = this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                'yyyy-MM-dd'))[1];

                        //查询 PUE
                        var pues=await queryPueBySysRooms(this.sysRoomIdsArr,startTime,endTime);
                        this.pueInfos=this.sumByRoomIdCompute(pues);

                        var infoArr=await queryFsi(this.deptIds,startTime,endTime);
                        this.finalDeptInfos=this.forEachEqualsInfo(infoArr,this.permissionDeptList);


                    }else{
                        var startTime=this.searchMouth.split('-')[0]+'-10-01';
                        var endTime = this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                'yyyy-MM-dd'))[1];

                        //查询 PUE
                        var pues=await queryPueBySysRooms(this.sysRoomIdsArr,startTime,endTime);
                        this.pueInfos=this.sumByRoomIdCompute(pues);

                        var infoArr=await queryFsi(this.deptIds,startTime,endTime);
                        this.finalDeptInfos=this.forEachEqualsInfo(infoArr,this.permissionDeptList);


                    }
                }else{
                    this.finalDeptInfos=[];
                    this.pueInfos=[];
                }
            },
           async handleClick(tab, event){
               if(tab.name=='first'){//综合
                   if(this.searchMouth.match('-03')||this.searchMouth.match('-06')||this.searchMouth.match('-09')||this.searchMouth.match('-12')){
                       if(this.searchMouth.match('-03')){
                           var startTime=this.searchMouth.split('-')[0]+'-01-01';
                           var endTime = this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                   'yyyy-MM-dd'))[1];
                           var infoArr=await queryFsi(this.deptIds,startTime,endTime);
                           this.finalDeptInfos=this.forEachEqualsInfo(infoArr,this.permissionDeptList);
                       }else if(this.searchMouth.match('-06')){
                           var startTime=this.searchMouth.split('-')[0]+'-04-01';
                           var endTime = this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                   'yyyy-MM-dd'))[1];
                           var infoArr=await queryFsi(this.deptIds,startTime,endTime);
                           this.finalDeptInfos=this.forEachEqualsInfo(infoArr,this.permissionDeptList);
                       }else if(this.searchMouth.match('-09')){
                           var startTime=this.searchMouth.split('-')[0]+'-07-01';
                           var endTime = this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                   'yyyy-MM-dd'))[1];
                           var infoArr=await queryFsi(this.deptIds,startTime,endTime);
                           this.finalDeptInfos=this.forEachEqualsInfo(infoArr,this.permissionDeptList);
                       }else{
                           var startTime=this.searchMouth.split('-')[0]+'-10-01';
                           var endTime = this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                   'yyyy-MM-dd'))[1];
                           var infoArr=await queryFsi(this.deptIds,startTime,endTime);
                           this.finalDeptInfos=this.forEachEqualsInfo(infoArr,this.permissionDeptList);
                       }
                   }else{
                       this.finalDeptInfos=[];
                   }
               }else if(tab.name=='second'){//PUE
                   if(this.searchMouth.match('-03')||this.searchMouth.match('-06')||this.searchMouth.match('-09')||this.searchMouth.match('-12')){
                       if(this.searchMouth.match('-03')){
                           var startTime=this.searchMouth.split('-')[0]+'-01-01';
                           var endTime = this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                   'yyyy-MM-dd'))[1];
                           //查询 PUE
                           var pues=await queryPueBySysRooms(this.sysRoomIdsArr,startTime,endTime);
                           this.pueInfos=this.sumByRoomIdCompute(pues);
                       }else if(this.searchMouth.match('-06')){
                           var startTime=this.searchMouth.split('-')[0]+'-04-01';
                           var endTime = this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                   'yyyy-MM-dd'))[1];
                           //查询 PUE
                           var pues=await queryPueBySysRooms(this.sysRoomIdsArr,startTime,endTime);
                           this.pueInfos=this.sumByRoomIdCompute(pues);
                       }else if(this.searchMouth.match('-09')){
                           var startTime=this.searchMouth.split('-')[0]+'-07-01';
                           var endTime = this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                   'yyyy-MM-dd'))[1];
                           //查询 PUE
                           var pues=await queryPueBySysRooms(this.sysRoomIdsArr,startTime,endTime);
                           this.pueInfos=this.sumByRoomIdCompute(pues);

                       }else{
                           var startTime=this.searchMouth.split('-')[0]+'-10-01';
                           var endTime = this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                   'yyyy-MM-dd'))[1];
                           //查询 PUE
                           var pues=await queryPueBySysRooms(this.sysRoomIdsArr,startTime,endTime);
                           this.pueInfos=this.sumByRoomIdCompute(pues);
                       }
                   }else{
                       this.pueInfos=[];
                   }
               }else if(tab.name=='third'){//监察
                   var infos=await queryLooksInfo(this.searchMouth);
                   this.looks=this.sortFractionLook(infos);
                   this.looks.forEach(e =>{
                       this.deptList.forEach(h => {
                            if (e.assessmentobj == h.id) {
                                e.assessmentobjname = h.name;
                            }
                        })
                   })

               }else{//安全指数
                   if(this.searchMouth.match('-03')||this.searchMouth.match('-06')||this.searchMouth.match('-09')||this.searchMouth.match('-12')){
                       if(this.searchMouth.match('-03')){
                           var startTime=this.searchMouth.split('-')[0]+'-01-01';
                           var endTime = this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                   'yyyy-MM-dd'))[1];
                           var infoArr=await queryFsi(this.deptIds,startTime,endTime);
                           this.finalDeptInfos=this.forEachEqualsInfo(infoArr,this.permissionDeptList);
                       }else if(this.searchMouth.match('-06')){
                           var startTime=this.searchMouth.split('-')[0]+'-04-01';
                           var endTime = this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                   'yyyy-MM-dd'))[1];
                           var infoArr=await queryFsi(this.deptIds,startTime,endTime);
                           this.finalDeptInfos=this.forEachEqualsInfo(infoArr,this.permissionDeptList);
                       }else if(this.searchMouth.match('-09')){
                           var startTime=this.searchMouth.split('-')[0]+'-07-01';
                           var endTime = this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                   'yyyy-MM-dd'))[1];
                           var infoArr=await queryFsi(this.deptIds,startTime,endTime);
                           this.finalDeptInfos=this.forEachEqualsInfo(infoArr,this.permissionDeptList);
                       }else{
                           var startTime=this.searchMouth.split('-')[0]+'-10-01';
                           var endTime = this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                                   'yyyy-MM-dd'))[1];
                           var infoArr=await queryFsi(this.deptIds,startTime,endTime);
                           this.finalDeptInfos=this.forEachEqualsInfo(infoArr,this.permissionDeptList);
                       }
                   }else{
                       this.finalDeptInfos=[];
                   }
               }

            },
            addZero(num) {
                if (parseInt(num) < 10) {
                    num = '0' + num;
                }
                return num;
            },
            //获取vue的actions里面的方法，添加到此处的methods
            //...deptNSHelper.mapActions(['getDeptSource']),
            //获取当前年月日时间，月出（一号）到月末（31或者30号）
            getTheMonthFirstLastDay(dateStr, fmt){
                    var date = new Date(dateStr);
                    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
                    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                    return [firstDay.Format(fmt), lastDay.Format(fmt)];
            },
            //循环比对部门ID是否一样，一样把名字加到集合中去，并且排序
            forEachEqualsInfo(oneInfo,twoInfo){

                oneInfo.forEach(e =>{
                    twoInfo.forEach(h =>{
                        if(e.id==h.id){
                            e.name=h.name;
                        }
                    })
                })
                oneInfo.sort(function(a,b){
                    return b.total - a.total;
                });
                return this.sortFractionCount(oneInfo);
            },
            //比较排序
            compareInfo(property) {
                return function (a, b) {
                    var value1 = a[property];
                    var value2 = b[property];
                    return value1 - value2;
                }
            },
            //比较排序
            compareInfo2(property) {
                return function (a, b) {
                    var value1 = a[property];
                    var value2 = b[property];
                    return value2 - value1;
                }
            },
            //根据roomId计算总和
            sumByRoomIdCompute(array){
                //排序
                var dcnumGroupedTotalInfo =array.sort(this.compareInfo("roomId"));
                //分组
                var map = new Map();
                for(var n=0;n<dcnumGroupedTotalInfo.length;n++){
                    if(map.get(dcnumGroupedTotalInfo[n].roomId)){
                        var value=map.get(dcnumGroupedTotalInfo[n].roomId);
                        var dcnumGroupedTotalInfoNew=dcnumGroupedTotalInfo[n];
                        //相同的roomId相加
                        value.recordITAmount=value.recordITAmount+dcnumGroupedTotalInfoNew.recordITAmount;
                        value.recordRoomAmount=value.recordRoomAmount+dcnumGroupedTotalInfoNew.recordRoomAmount;
                        var sysRoomName=this.sysRoomMap.get(value.roomId);
                        value.sysRoomName=sysRoomName;
                        map.set(value.roomId,value);
                    }else{
                        var dcnumGroupedTotalInfoNew=JSON.parse(JSON.stringify(dcnumGroupedTotalInfo[n]));
                        var sysRoomName=this.sysRoomMap.get(dcnumGroupedTotalInfoNew.roomId);
                        dcnumGroupedTotalInfoNew.sysRoomName=sysRoomName;
                        map.set(dcnumGroupedTotalInfo[n].roomId,dcnumGroupedTotalInfoNew);
                    }
                }
                //map转集合
                var roomIdGroupedTotalInfo=[...map.values()];
                //在循环一次计算recordITAmount/recordRoomAmount得到pue的值,值越小越靠前
                for(var a=0;a<roomIdGroupedTotalInfo.length;a++) {
                    roomIdGroupedTotalInfo[a].pueAmountNew = roomIdGroupedTotalInfo[a].recordRoomAmount / roomIdGroupedTotalInfo[a].recordITAmount;
                    if (isNaN(roomIdGroupedTotalInfo[a].pueAmountNew) || roomIdGroupedTotalInfo[a].pueAmountNew <= 1) {//测试丹初提供的需求，如果算出来PUE<=1要去除
                        delete roomIdGroupedTotalInfo[a];
                    }
                }
                var roomIdGroupedTotalInfoNew=[];

                for(var a=0;a<roomIdGroupedTotalInfo.length;a++){
                    if(null!=roomIdGroupedTotalInfo[a]||roomIdGroupedTotalInfo[a]!=undefined){//测试丹初提供的需求，如果算出来PUE<=1要去除
                        roomIdGroupedTotalInfoNew.push(roomIdGroupedTotalInfo[a]);
                    }
                }

                //在按照PUE 的值排序
                roomIdGroupedTotalInfoNew.sort(this.compareInfo("pueAmountNew"));

                return this.sortFractionPue(roomIdGroupedTotalInfoNew);
               // return roomIdGroupedTotalInfoNew;
            },
            sortFractionPue(listInfo){

                let prescore = 0;//预定义分数
                let ranking = 0;//排名

                listInfo.forEach((item,index)=>{
                    if(item.pueAmountNew==prescore){
                    item.ranking = ranking;
                }else{
                    ranking++;
                    prescore = item.pueAmountNew;
                    item.ranking = ranking;
                }
                })
                return listInfo;
             },
            sortFractionCount(listInfo){

                let prescore = 0;//预定义分数
                let ranking = 0;//排名

                listInfo.forEach((item,index)=>{
                if(item.total==prescore){
                    item.ranking = ranking;
                }else{
                    ranking++;
                    prescore = item.total;
                    item.ranking = ranking;
                }
            })
                return listInfo;
            },
            sortFractionLook(listInfo){

                let prescore = 0;//预定义分数
                let ranking = 0;//排名

                listInfo.forEach((item,index)=>{
                    if(item.totalscore==prescore){
                    item.ranking = ranking;
                }else{
                    ranking++;
                    prescore = item.totalscore;
                    item.ranking = ranking;
                }
            })
                return listInfo;
            }
        },
        async created(){


            //获取有权限的园区（部门）供安全指数TAB和综合页面使用
            this.permissionDeptList=await queryPrimissionDepts();
            this.deptList=this.permissionDeptList;

            this.permissionDeptList.forEach(e =>{
                this.deptIds.push(e.id);
            })

            //监察查询
            var infos=await queryLooksInfo(this.searchMouth);
            this.looks=this.sortFractionLook(infos);
            this.looks.forEach(e =>{
                    this.deptList.forEach(h => {
                if (e.assessmentobj == h.id) {
                    e.assessmentobjname = h.name;
                }
            })
            });


            //PUE 页面查询根据有权限的部门查询下面的数据中心
            this.SysRooms=await queryDcnumByDepts(this.deptIds);

            //给MAP赋值数据中心ID和名称供后续根据ID转换名称使用
            this.sysRoomMap= new Map();
            this.SysRooms.forEach(e =>{
                //只有sysRoomID集合
                this.sysRoomIdsArr.push(e.id);
                this.sysRoomMap.set(e.id + '', e.name);
            })

            //查询综合和安全指数的同时一起查询PUE
            if(this.searchMouth.match('-03')||this.searchMouth.match('-06')||this.searchMouth.match('-09')||this.searchMouth.match('-12')){
                if(this.searchMouth.match('-03')){
                    //查询综合和安全指数
                    var startTime=new Date().getFullYear()+'-01-01';
                    var endTime = this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                            'yyyy-MM-dd'))[1];

                    //查询 PUE
                    var pues=await queryPueBySysRooms(this.sysRoomIdsArr,startTime,endTime);
                    this.pueInfos=this.sumByRoomIdCompute(pues);

                    var infoArr=await queryFsi(this.deptIds,startTime,endTime);
                    this.finalDeptInfos=this.forEachEqualsInfo(infoArr,this.permissionDeptList);


                }else if(this.searchMouth.match('-06')){
                    //查询综合和安全指数
                    var startTime=new Date().getFullYear()+'-04-01';
                    var endTime = this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                            'yyyy-MM-dd'))[1];

                    //查询 PUE
                    var pues=await queryPueBySysRooms(this.sysRoomIdsArr,startTime,endTime);
                    this.pueInfos=this.sumByRoomIdCompute(pues);

                    var infoArr=await queryFsi(this.deptIds,startTime,endTime);
                    this.finalDeptInfos=this.forEachEqualsInfo(infoArr,this.permissionDeptList);


                }else if(this.searchMouth.match('-09')){
                    //查询综合和安全指数
                    var startTime=new Date().getFullYear()+'-07-01';
                    var endTime = this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                            'yyyy-MM-dd'))[1];

                    //查询 PUE
                    var pues=await queryPueBySysRooms(this.sysRoomIdsArr,startTime,endTime);
                    this.pueInfos=this.sumByRoomIdCompute(pues);

                    var infoArr=await queryFsi(this.deptIds,startTime,endTime);
                    this.finalDeptInfos=this.forEachEqualsInfo(infoArr,this.permissionDeptList);



                }else{
                    //查询综合和安全指数
                    var startTime=new Date().getFullYear()+'-10-01';
                    var endTime = this.getTheMonthFirstLastDay(this.searchMouth + "-01", (
                            'yyyy-MM-dd'))[1];

                    //查询 PUE
                    var pues=await queryPueBySysRooms(this.sysRoomIdsArr,startTime,endTime);
                    this.pueInfos=this.sumByRoomIdCompute(pues);

                    var infoArr=await queryFsi(this.deptIds,startTime,endTime);
                    this.finalDeptInfos=this.forEachEqualsInfo(infoArr,this.permissionDeptList);


                }
            }else{
                this.finalDeptInfos=[];
                this.pueInfos=[];
            }


        },
        mounted() {
            //this.getDeptSource();
            //this.deptSource$.subscribe(v => {
            //this.deptList = v;
            //});


        },
        computed: {
          //  ...deptNSHelper.mapGetters(['deptSource$']),
        },

    }
</script>